// zoomPicではpopupの値を参照することにしたので、テスタビリティを担保するためのstub
import Constants from "@/views/enterprise/rg-object-history/Constants";

// マスター制御
// zoomPicStub()内で判定してもいいが、stub関数自体を毎回確定で呼ぶのは不健康なので判定を呼び出し元で明示
export const doZoomPicStub =
  process.env.VUE_APP_FEATURES_RG_ZOOM_PIC_STUB_ON_POPUP === "true";
// このモジュールからRgPopup.data().zoomPicStubDoingに初期値を代入させることで、vueインスタンスのプロパティ
// からの依存関係を明示
export const zoomPicStubDoingInit = false;

const rollingDurationMss = {
  imgUrl: 3000,
  riskLevel: 750,
  trackNumber: 1000,
  aiseaCameraName: 1500,
};

// 丸囲み数字①〜⑤の、base64エンコード画像
// フィーチャーフラグがONの時だけ配列型文字列が渡ってくる
const base64UrlsStr = process.env.VUE_APP_RG_ZOOM_PIC_STUB_ON_POPUP_BASE64_URLS;
const base64Urls = base64UrlsStr ? JSON.parse(base64UrlsStr) : [];

const riskLevels = Object.values(Constants.RG_RISK_LEVEL);
const newArray = (length, indexMapper = (_index) => {}) =>
  Array.from(new Array(length)).map((_, index) => indexMapper(index));
const trackNumbers = newArray(10, (index) => index.toString().padEnd(6, "3"));
const aiseaCameraNames = newArray(10, (index) => `カメラ - ${index}`);

const setTimewait = (durationMs) =>
  new Promise((resolve) => setTimeout(resolve, durationMs));

const indexToNext = (loopingArray, index) =>
  index === loopingArray.length - 1 ? 0 : index + 1;

const recurse = async (array, durationMs, eachFunc, index = 0) => {
  if (array.length === 0) return;
  await setTimewait(durationMs);
  const element = array[index];
  eachFunc(element, index);
  const indexNext = indexToNext(array, index);
  recurse(array, durationMs, eachFunc, indexNext);
};

// vueインスタンスの参照が切れないので、recurseもろともdisposeするにはclose系イベントから
// アクションしないといけないが、開発用で普段は動き出さないので、そこまではしないことにした
export const zoomPicStub = (rgPopupVue) => {
  rgPopupVue.zoomPicStubDoing = true;

  const { imgUrl, trackNumber, riskLevel, aiseaCameraName } =
    rollingDurationMss;

  recurse(base64Urls, imgUrl, (element, _index) => {
    rgPopupVue.imgUrl = element;
  });

  recurse(trackNumbers, trackNumber, (element, _index) => {
    rgPopupVue.trackNumber = element;
  });

  recurse(riskLevels, riskLevel, (element, _index) => {
    rgPopupVue.riskLevel = element;
  });

  const mapHasCameraName = rgPopupVue.cameraHashMap[rgPopupVue.aiseaCameraHash];
  if (!mapHasCameraName) return;
  recurse(aiseaCameraNames, aiseaCameraName, (element, _index) => {
    mapHasCameraName.name = element;
  });
};

export default {
  doZoomPicStub,
  zoomPicStub,
  zoomPicStubDoingInit,
};
